import { render, staticRenderFns } from "./TaskListClearCompletedTasks.vue?vue&type=template&id=768e8943&scoped=true"
import script from "./TaskListClearCompletedTasks.vue?vue&type=script&lang=js"
export * from "./TaskListClearCompletedTasks.vue?vue&type=script&lang=js"
import style0 from "./TaskListClearCompletedTasks.vue?vue&type=style&index=0&id=768e8943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768e8943",
  null
  
)

export default component.exports